module.exports = __webpack_public_path__ + "img/NEW.ae72a4ec.svg";